import ToggleButton from "../../02-molecules/Buttons/buttonToggle";
import ScrollTo from "@init/scrolltojs";

export default class MoreButton extends ToggleButton {
  /**
   * creates an instance of ToggleButton
   * @extends ToggleButton
   */
  constructor() {
    super("[data-js-button='button-more']"); // call ToggleButton-Instance

    this.loadMoreButtonSelector = "[data-js-button='button-more']";

    // elements
    this.loadMoreButton = document.querySelector(this.loadMoreButtonSelector);
    this.loadMoreButtonLabel = this.loadMoreButton.querySelector(
      ".egat-button__label"
    );

    this.target = document.querySelector("[data-js-scroll='target']");
    this.scrollTarget = this.target.closest(".egat-content-grid");

    // arrays
    this.teaserArray = Array.from(
      document.querySelectorAll(".egat-pageteaser .egat-textimage")
    );

    this.moreTitle = this.loadMoreButton.getAttribute("data-closed-title");
    this.lessTitle = this.loadMoreButton.getAttribute("data-opened-title");

    this.defaultEvent();
  }

  defaultEvent() {
    if (this.teaserArray && this.loadMoreButton) {
      this.loadMoreButton.setAttribute("title", this.moreTitle);
      this.loadMoreButtonLabel.innerHTML = this.moreTitle;
      const toBeToggledArray = this.teaserArray.filter(
        (element, index) => index > 2
      );
      this.loadMoreButton.addEventListener("click", () => {
        this.toggleAriaExpanded(this.loadMoreButton);

        if (this.loadMoreButton.getAttribute("title") == this.moreTitle) {
          this.toggleTitle(this.loadMoreButton);
          this.loadMoreButtonLabel.innerHTML = this.lessTitle;
          new ScrollTo(this.scrollTarget, { align: "center" }).go();
        } else {
          this.toggleTitle(this.loadMoreButton);
          this.loadMoreButtonLabel.innerHTML = this.moreTitle;
          new ScrollTo(this.scrollTarget, { align: "top" }).go();
        }
        toBeToggledArray.forEach(teaser => {
          teaser.classList.toggle(this.hiddenClass);
        });
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new MoreButton();
});
